import { css } from '@/styled-system/css';

export const waitlistNotice = css({
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderColor: 'hpxGrey100',
  fontSize: 'sm',
});
